import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getDocumentoPrioritario (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getTipoEsquema)
    })
  } else {
    const req = {
      url: 'api/facturas/GetDocumentoPrioritario',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getDocumentoPrioritario }
